<template lang="pug">
  v-text-field(
    v-model.trim="search"
    :placeholder="placeholder"
    filled
    hide-details
    clearable
    class="my-0 flex-grow"
    v-bind="$attrs"
  )
    template(#prepend-inner)
      e-svg-icon(
        class="mr-1"
        name="search-gray"
      )
</template>

<script>
import responsive from '~/mixins/pages/responsive'

export default {
  name: 'EInputDebounce',
  mixins: [responsive],
  props: {
    placeholder: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      search: null,
      debouncedSearchFn: null,
      debouncedSearch: null
    }
  },
  watch: {
    search(val) {
      this.debouncedSearchFn(val)
    }
  },
  created() {
    const querySearchValue = this._.get(this.$route, 'query.search')
    if (querySearchValue) {
      this.search = querySearchValue
    }
  },
  mounted() {
    this.debouncedSearchFn = this._.debounce(this.setSearchString, 800)
  },
  methods: {
    setSearchString(value) {
      this.debouncedSearch = value
      this.$emit('input', value)
    }
  }
}
</script>

<style scoped lang="scss"></style>
